window.addEventListener('scroll', () => {
    const ctaBanners = document.querySelectorAll('.c-cta-banner');
    for (let i = 0; i < ctaBanners.length; i += 1) {
        const position = ctaBanners[i].getBoundingClientRect();
        if (position.top < window.innerHeight && position.bottom >= 0) {
            ctaBanners[i].classList.add('show');
        }
    }
});
